import { Divider } from '@faceup/ui-base'
import { type FragmentType, getFragmentData, graphql } from '../../../../__generated__'
import { useReportMenuItems } from '../../../../hooks/useReportMenuItems'
import LanguageDropdown from '../../../LanguageDropdown'
import { MenuItems } from '../../../MenuItems/MenuItems'

const fragments = {
  InstitutionLayoutWebFooter_reportSource: graphql(`
    fragment InstitutionLayoutWebFooter_reportSource on PublicReportSource {
      id
      languages
      defaultLanguage
      institution {
        id
        billing {
          id
          plan
        }
      }
    }
  `),
}

type WebFooterProps = {
  reportSource: FragmentType<typeof fragments.InstitutionLayoutWebFooter_reportSource>
  shouldShowLanguagesDropdown: boolean
}

export const WebFooter = ({
  reportSource: _reportSource,
  shouldShowLanguagesDropdown,
}: WebFooterProps) => {
  const reportSource = getFragmentData(
    fragments.InstitutionLayoutWebFooter_reportSource,
    _reportSource
  )
  const reportMenuItems = useReportMenuItems({
    plan: reportSource.institution?.billing?.plan,
  })

  return (
    <div className='fixed bottom-0 left-0 right-0'>
      <Divider />
      <div
        className={
          shouldShowLanguagesDropdown ? '' : 'invisible absolute pointer-events-none opacity-0'
        }
      >
        <div className='px-6 py-3 bg-white'>
          <LanguageDropdown
            availableLanguages={reportSource.languages}
            defaultLanguage={reportSource.defaultLanguage}
          />
        </div>
        <Divider />
      </div>
      <div>
        <div className='p-6 bg-white'>
          <MenuItems items={reportMenuItems} />
        </div>
      </div>
    </div>
  )
}
